<template>
  <v-container id="ur-list">
    <v-row>
      <v-col>Unidades Regionais</v-col>

      <v-col class="text-right">
        <v-btn color="primary" @click="gerarXls">
          Relatório UR x
          {{
            isParceiro
              ? "Parceiros"
              : isSala
              ? "Salas"
              : isGov
              ? "Projetos"
              : "Municípios"
          }}</v-btn
        >
        <app-modal-insert-ur
          :edit="false"
          :object="null"
          :color="'success'"
          :icon="'mdi-plus-circle'"
          @on-save="loadUrs"
        >
          <template v-slot:title :edit="false">
            Cadastrar Unidades Regionais
          </template>
        </app-modal-insert-ur>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.nome="{ item }">
            <span>
              {{ item.nomeRegiao }}
            </span>
          </template>

          <template v-slot:item.acoes="{ item }">
            <v-row>
              <v-col cols="1">
                <app-modal-insert-ur
                  :object="item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                  @on-save="loadUrs"
                >
                  <template v-slot:title> Edição de Unidade Regional </template>
                </app-modal-insert-ur>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.acoes_delete="{ item }">
            <v-row>
              <v-col cols="1">
                <app-modal-delete :object="item" @on-save="loadUrs">
                  <template v-slot:title> Deletar UR </template>
                </app-modal-delete>
              </v-col>

              <v-col cols="1"> </v-col>
            </v-row>
          </template>

          <template slot="no-data">
            <span> Nenhuma Unidade Regional retornada </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsertUr from "./ModalInsert";
import { urAPI } from "../API/urAPI";
import { mapActions, mapGetters } from "vuex";
import AppModalDelete from "./../components/ModalDelete";
import { criarLinkRelatorio } from "@/helpers/gerarRelatorio";
import moment from "moment";

export default {
  components: {
    AppModalInsertUr,
    AppModalDelete,
  },
  data() {
    return {
      headers: [
        { text: "Unidade Regional", value: "nome" },
        { text: "Editar", value: "acoes", sortable: false },
        { text: "Excluir", value: "acoes_delete", sortable: false },
      ],
      payload: [],
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    gerarXls() {
      this.setLoading(true);
      urAPI
        .xlsUnidadeRegional(this.municipioId)
        .then((resp) => {
          this.setLoading(false);
          const nome = `Relatório de Unidades Regionais por 
          ${this.isGov ? "Projetos" : "Municípios"}
          - ${moment().format("DD_MM_YYYY_HH_mm")}`;
          criarLinkRelatorio(resp.data, nome);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatorio final");
        });
    },
    loadUrs() {
      this.setLoading(true);
      urAPI
        .getByUf(this.$store.state.uf)
        .then((resp) => {
          this.payload = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter URs");
        });
    },
  },
  mounted() {
    this.loadUrs();
  },
  computed: {
    ...mapGetters(["isParceiro", "isSala", "isGov"]),
  },
};
</script>
